import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import useRequest from "../../../utils/useRequest";
import usePrint from "../../../utils/hooks/usePrint";

import PageWrapper from "../../../components/PageWrapper";
import ItemInvoiceHeader from "./ItemInvoiceHeader";
import ItemInvoiceBody from "./ItemInvoiceBody";
import ItemInvoiceFooter from "./ItemInvoiceFooter";
import ErrorBox from "../../../components/ErrorBox";
import { useRef } from "react";
import Loader from "../../../components/Loader";

export default function ViewItemInvoice() {
  const { id } = useParams();
  const { t } = useTranslation("general");
  const printRef = useRef(null);

  const { data, setData, loading, error, refetch } = useRequest(
    `/getOneItemInvoice/${id}`,
    "GET",
    null,
    null,
    true
  );

  const { handlePrint } = usePrint();

  const print = () => handlePrint(printRef.current.innerHTML);

  return (
    <PageWrapper withBackButton={true} ref={printRef}>
      {loading ? (
        <Loader />
      ) : error ? (
        <ErrorBox>{t(error)}</ErrorBox>
      ) : (
        <div className="o-column u-height_screen-height">
          <ItemInvoiceHeader invoiceHeader={data?.document?.[0]?.path} />

          <ItemInvoiceBody
            data={data}
            setData={setData}
            mode="view"
            handlePrint={print}
          />
          <ItemInvoiceFooter />
        </div>
      )}
    </PageWrapper>
  );
}
